import { Link } from 'react-router-dom';
import './SolutionsCTA.css';
import housePhoto from '../../assets/figma_sol_battery.jpg';

const features = [
  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
        <circle cx="26" cy="26" r="24" stroke="#eaff50" strokeWidth="1.8"/>
        <line x1="26" y1="14" x2="26" y2="38" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M20 19.5C20 17 22.69 15 26 15s6 2 6 4.5S28.69 24 26 24s-6 2-6 4.5S22.69 33 26 33s6-2 6-4.5" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M20 36l12-12" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M29 38l3-3-3-3" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Save More, Every Year',
    desc: 'Smart solar and battery systems help reduce your energy costs and increase long-term savings.',
  },
  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
        <circle cx="26" cy="26" r="24" stroke="#eaff50" strokeWidth="1.8"/>
        <path d="M29 15l-10 13h9l-5 9 11-14h-9l4-8z" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Energy That Works Differently',
    desc: 'We design systems around how your home uses energy, now and in the future.',
  },
  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
        <circle cx="26" cy="26" r="24" stroke="#eaff50" strokeWidth="1.8"/>
        <path d="M34 36v-2a5 5 0 00-5-5h-6a5 5 0 00-5 5v2" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round"/>
        <circle cx="26" cy="22" r="4" stroke="#eaff50" strokeWidth="1.8"/>
        <path d="M38 36v-2a5 5 0 00-3-4.6M36 16.1a5 5 0 010 7.8" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Speak With Our Team',
    desc: "Let's find the right solution for your home. We're here to help.",
  },
];

export default function SolutionsCTA() {
  return (
    <section className="sc-section">
      <div className="sc-inner">
        <div className="sc-card">

          {/* Left white panel */}
          <div className="sc-left">
            <div className="sc-eyebrow-row">
              <div className="sc-eyebrow-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="#1a6fcc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div>
                <p className="sc-eyebrow">TAKE CONTROL</p>
                <p className="sc-eyebrow-sub">Smarter energy. Lower bills.</p>
              </div>
            </div>

            <h2 className="sc-heading">
              Ready to Take Control<br/>
              of Your <span className="sc-heading-accent">Electricity Bills?</span>
            </h2>

            <div className="sc-divider" />

            <p className="sc-body">
              Every home uses energy differently. Speak with our team for a tailored solar and battery assessment designed around your household's energy needs.
            </p>

            <div className="sc-photo">
              <img src={housePhoto} alt="Home solar and battery system" />
            </div>
          </div>

          {/* Right dark panel */}
          <div className="sc-right">
            <div className="sc-features">
              {features.map((f, i) => (
                <div key={f.title}>
                  {i > 0 && <div className="sc-feat-divider" />}
                  <div className="sc-feature">
                    <div className="sc-feat-icon">{f.icon}</div>
                    <div className="sc-feat-text">
                      <h4 className="sc-feat-title">{f.title}</h4>
                      <p className="sc-feat-desc">{f.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/contact" className="sc-cta-btn">
              Get My Free Quote <span>→</span>
            </Link>

            <div className="sc-no-pressure">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7l-9-5z" stroke="#eaff50" strokeWidth="1.7" strokeLinejoin="round"/>
                <path d="M9 12l2 2 4-4" stroke="#eaff50" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div>
                <p className="sc-no-pressure-title">No pressure. No obligation.</p>
                <p className="sc-no-pressure-sub">100% obligation-free quotes.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
